import React from "react";
import { Router, Switch, Route } from "react-router-dom";
import Spending from "./pages/Spending";
import Analytics from "./pages/Analytics";
import Settings from "./pages/Settings";
import Login from "./pages/Login";
import Register from "./pages/Register";
import NavBar from "./components/NavBar";
import history from "./utils/history";

function App() {
  return (
    <Router history={history}>
      <Switch>
        {/* 全版面（無導覽列）的頁面 */}
        <Route path="/login">
          <Login />
        </Route>
        <Route path="/register">
          <Register />
        </Route>
        {/* 其餘頁面共用導覽列 */}
        <Route path="/">
          <NavBar />
          <Switch>
            <Route path="/analytics">
              <Analytics />
            </Route>
            <Route path="/settings">
              <Settings />
            </Route>
            <Route path="/">
              <Spending />
            </Route>
          </Switch>
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
